export default __webpack_public_path__ + "static/media/Buy.ecd78559.svg";